/**
 * Widget de chat Laura — bacgraisse.com
 * Vanilla JS, aucune dépendance. Historique en sessionStorage.
 *
 * Intégration : <script src="..." data-endpoint="https://bacgraisse-chat.curly-haze-bfdd.workers.dev/chat" defer></script>
 */
(function () {
  'use strict';
  if (window.__lauraChat) return;
  window.__lauraChat = true;

  var S = document.currentScript || (function () {
    var all = document.getElementsByTagName('script');
    return all[all.length - 1];
  })();

  var ENDPOINT = (S && S.getAttribute('data-endpoint')) || 'https://bacgraisse-chat.curly-haze-bfdd.workers.dev/chat';
  var BASE = ENDPOINT.replace(/\/chat\/?$/, '');
  var RATE_URL = BASE + '/rate';
  var EVENT_URL = BASE + '/event';

  // Langue de la boutique : data-lang sur la balise script, sinon l'attribut
  // lang de la page. Un seul fichier pour les trois sites, et pour ceux qui
  // viendront : il suffit d'ajouter une entrée dans T.
  var LANG = (S && S.getAttribute('data-lang')) || (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();

  // Deux boutiques peuvent partager une langue sans partager leurs textes :
  // separateur-graisse.fr est en français mais a sa marque, ses URLs et sa charte.
  // data-tenant l'emporte donc sur la langue ; sans attribut, on garde la langue.
  // Côté Worker, la boutique reste déduite de l'Origin : cet attribut ne sert
  // qu'à l'habillage du widget, il n'ouvre aucun accès.
  var TENANT = (S && S.getAttribute('data-tenant')) || LANG;

  // Masque la bulle flottante quand le site a son propre point d'entrée (bouton d'en-tête).
  var BULLE_OFF = S && String(S.getAttribute('data-bulle')).toLowerCase() === 'off';

  var TEXTES = {
    fr: {
      email: 'contact@bacgraisse.com',
      telephone: '01 84 80 50 34',
      titre: 'Laura',
      statut: 'En ligne',
      ouvrir: 'Ouvrir le chat',
      fermer: 'Fermer le chat',
      saisie: 'Votre question...',
      envoyer: 'Envoyer',
      ecrit: 'Laura écrit',
      accueil:
        ', je suis Laura du service client BAC GRAISSE 👋\n' +
        'Une question sur votre bac à graisse ? Dimensionnement, dimensions, livraison : je vous réponds tout de suite.',
      bonjour: ['Bonjour', 'Bonsoir'],
      suggestions: [
        'Quel modèle pour mon restaurant ?',
        'Quelles sont les dimensions ?',
        'Quels sont les délais de livraison ?',
        'Le bac est-il conforme NF EN 1825 ?',
      ],
      relance: "Avez-vous d'autres questions ?",
      conge: ['Je vous souhaite une bonne journée, à très vite 🙂', 'Je vous souhaite une bonne soirée, à très vite 🙂'],
      note: 'Une dernière chose : quelle note donneriez-vous à cet échange ?',
      merci_haut: 'Merci beaucoup, cela nous aide 🙏',
      merci_bas: 'Merci, votre retour est transmis à l’équipe.',
      fin_re: /(bonne journée|bonne soirée|bonne fin de journée|à très vite|à bientôt|au plaisir)/i,
      calculateur: 'https://www.bacgraisse.com/pages/calculateur-de-capacite',
      comparaison:
        ', je vois que vous comparez plusieurs modèles. Si vous hésitez sur la taille, notre calculateur vous donne le bon volume en 30 secondes.\n',
      cta: 'Discuter avec Laura, réponse immédiate',
      panne: "Je n'arrive pas à vous répondre à l'instant. Écrivez à ",
      panne2: ' ou appelez le ',
      coupure: "La connexion a échoué. Vous pouvez joindre l'équipe au ",
      contact_re: /\/pages\/contact|nous-contacter|contactez/i,
      // Bleu marine de bacgraisse.com.
      couleur: '#1a365c',
      couleur2: '#24507f',
      ombre: 'rgba(26,54,92',
    },

    // separateur-graisse.fr : même conseillère, même équipe, mais son vocabulaire
    // (« séparateur », jamais « bac »), ses URLs et sa charte (noir #111).
    // Sélectionné par data-tenant="sg" sur la balise script, pas par la langue.
    sg: {
      email: 'contact@separateur-graisse.fr',
      telephone: '01 84 80 50 34',
      titre: 'Laura',
      statut: 'En ligne',
      ouvrir: 'Ouvrir le chat',
      fermer: 'Fermer le chat',
      saisie: 'Votre question...',
      envoyer: 'Envoyer',
      ecrit: 'Laura écrit',
      accueil:
        ', je suis Laura du service client SÉPARATEUR GRAISSE 👋\n' +
        'Une question sur votre séparateur de graisse ? Dimensionnement, dimensions, livraison : je vous réponds tout de suite.',
      bonjour: ['Bonjour', 'Bonsoir'],
      suggestions: [
        'Quel modèle pour mon restaurant ?',
        'Quelles sont les dimensions ?',
        'Quels sont les délais de livraison ?',
        'Est-il conforme NF EN 1825 ?',
      ],
      relance: "Avez-vous d'autres questions ?",
      conge: ['Je vous souhaite une bonne journée, à très vite 🙂', 'Je vous souhaite une bonne soirée, à très vite 🙂'],
      note: 'Une dernière chose : quelle note donneriez-vous à cet échange ?',
      merci_haut: 'Merci beaucoup, cela nous aide 🙏',
      merci_bas: 'Merci, votre retour est transmis à l’équipe.',
      fin_re: /(bonne journée|bonne soirée|bonne fin de journée|à très vite|à bientôt|au plaisir)/i,
      calculateur: 'https://separateur-graisse.fr/calculateur',
      comparaison:
        ', je vois que vous comparez plusieurs modèles. Si vous hésitez sur la taille, notre calculateur vous donne le bon volume en 30 secondes.\n',
      cta: 'Discuter avec Laura, réponse immédiate',
      panne: "Je n'arrive pas à vous répondre à l'instant. Écrivez à ",
      panne2: ' ou appelez le ',
      coupure: "La connexion a échoué. Vous pouvez joindre l'équipe au ",
      contact_re: /\/contact/i,
      // Noir de separateur-graisse.fr (--accent:#111111).
      couleur: '#111111',
      couleur2: '#333333',
      ombre: 'rgba(17,17,17',
    },

    es: {
      email: 'contacto@separadorgrasas.es',
      telephone: null,
      titre: 'Laura',
      statut: 'En línea',
      ouvrir: 'Abrir el chat',
      fermer: 'Cerrar el chat',
      saisie: 'Tu pregunta...',
      envoyer: 'Enviar',
      ecrit: 'Laura está escribiendo',
      accueil:
        ', soy Laura, del servicio de atención al cliente 👋\n' +
        '¿Tienes una duda sobre tu separador de grasas? Dimensionamiento, medidas, envío: te respondo al momento.',
      bonjour: ['Hola', 'Buenas tardes'],
      suggestions: [
        '¿Qué modelo necesito para mi restaurante?',
        '¿Cuáles son las medidas?',
        '¿Cuál es el plazo de entrega?',
        '¿Cumple la norma UNE-EN 1825?',
      ],
      relance: '¿Te puedo ayudar con algo más?',
      conge: ['Que tengas muy buen día, hasta pronto 🙂', 'Que tengas muy buena tarde, hasta pronto 🙂'],
      note: 'Una última cosa: ¿qué nota le pondrías a esta conversación?',
      merci_haut: 'Muchas gracias, nos ayuda mucho 🙏',
      merci_bas: 'Gracias, le paso tu comentario al equipo.',
      fin_re: /(buen día|buena tarde|buenas tardes|hasta pronto|hasta luego|un saludo)/i,
      calculateur: 'https://separadorgrasas.es/pages/calculadora-de-capacidad',
      comparaison:
        ', veo que estás comparando varios modelos. Si dudas con el tamaño, nuestra calculadora te da el volumen correcto en 30 segundos.\n',
      cta: 'Hablar con Laura, respuesta inmediata',
      panne: 'Ahora mismo no consigo responderte. Escríbenos a ',
      panne2: ' y te contestamos lo antes posible.',
      coupure: 'Se ha perdido la conexión. Puedes escribirnos a ',
      contact_re: /\/pages\/contacto|contactanos/i,
      // Noir du thème espagnol : #111111 est la couleur des boutons du site.
      couleur: '#111111',
      couleur2: '#2b2b2b',
      ombre: 'rgba(17,17,17',
    },

    it: {
      email: 'assistenza@separatorigrassi.it',
      telephone: null,
      titre: 'Laura',
      statut: 'Online',
      ouvrir: 'Apri la chat',
      fermer: 'Chiudi la chat',
      saisie: 'La sua domanda...',
      envoyer: 'Invia',
      ecrit: 'Laura sta scrivendo',
      accueil:
        ', sono Laura del servizio clienti 👋\n' +
        'Ha una domanda sul suo separatore di grassi? Dimensionamento, misure, spedizione: le rispondo subito.',
      bonjour: ['Buongiorno', 'Buonasera'],
      suggestions: [
        'Quale modello per il mio ristorante?',
        'Quali sono le misure?',
        'Quali sono i tempi di consegna?',
        'È conforme alla norma UNI EN 1825?',
      ],
      relance: 'Posso aiutarla con altro?',
      conge: ['Le auguro una buona giornata, a presto 🙂', 'Le auguro una buona serata, a presto 🙂'],
      note: 'Un’ultima cosa: che voto darebbe a questa conversazione?',
      merci_haut: 'Grazie mille, ci aiuta molto 🙏',
      merci_bas: 'Grazie, giro il suo riscontro al team.',
      fin_re: /(buona giornata|buona serata|a presto|a risentirci|buon proseguimento)/i,
      calculateur: 'https://www.separatorigrassi.it/pages/calcolatore-di-capacita',
      comparaison:
        ', vedo che sta confrontando più modelli. Se ha un dubbio sulla taglia, il nostro calcolatore le dà il volume giusto in 30 secondi.\n',
      cta: 'Parlare con Laura, risposta immediata',
      panne: 'In questo momento non riesco a risponderle. Ci scriva ad ',
      panne2: ' e le rispondiamo il prima possibile.',
      coupure: 'La connessione è caduta. Può scriverci ad ',
      contact_re: /\/pages\/contattateci|contatti/i,
      couleur: '#1a365c',
      couleur2: '#24507f',
      ombre: 'rgba(26,54,92',
    },

    // tableinox.com : même conseillère, même équipe, mais son catalogue et son
    // vocabulaire. Sélectionné par data-tenant="ti" sur la balise script, pas par
    // la langue : le site est français comme fr et sg.
    // Pas de calculateur ici, le choix se fait au format et non au volume : les
    // clés `calculateur` et `comparaison` sont volontairement absentes.
    ti: {
      email: 'contact@tableinox.com',
      telephone: '01 84 80 50 34',
      titre: 'Laura',
      statut: 'En ligne',
      ouvrir: 'Ouvrir le chat',
      fermer: 'Fermer le chat',
      saisie: 'Votre question...',
      envoyer: 'Envoyer',
      ecrit: 'Laura écrit',
      accueil:
        ', je suis Laura du service client TABLEINOX 👋\n' +
        'Une question sur nos tables inox ? Format, dosseret, livraison : je vous réponds tout de suite.',
      bonjour: ['Bonjour', 'Bonsoir'],
      suggestions: [
        'Quelle profondeur choisir, 600 ou 700 ?',
        'À quoi sert le dosseret ?',
        "L'étagère basse est-elle incluse ?",
        'Quels sont les frais de livraison ?',
      ],
      relance: "Avez-vous d'autres questions ?",
      conge: ['Je vous souhaite une bonne journée, à très vite 🙂', 'Je vous souhaite une bonne soirée, à très vite 🙂'],
      note: 'Une dernière chose : quelle note donneriez-vous à cet échange ?',
      merci_haut: 'Merci beaucoup, cela nous aide 🙏',
      merci_bas: 'Merci, votre retour est transmis à l’équipe.',
      fin_re: /(bonne journée|bonne soirée|bonne fin de journée|à très vite|à bientôt|au plaisir)/i,
      cta: 'Discuter avec Laura, réponse immédiate',
      panne: "Je n'arrive pas à vous répondre à l'instant. Écrivez à ",
      panne2: ' ou appelez le ',
      coupure: "La connexion a échoué. Vous pouvez joindre l'équipe au ",
      contact_re: /\/pages\/contact/i,
      // Noir du thème ATHENS de tableinox.com.
      couleur: '#111111',
      couleur2: '#2b2b2b',
      ombre: 'rgba(17,17,17',
    },
  };

  var T = TEXTES[TENANT] || TEXTES[LANG] || TEXTES.fr;
  var EMAIL = T.email;
  var PHONE = T.telephone;

  // Couleurs de la boutique : teinte principale, fin de dégradé et base des
  // ombres portées. Une ombre bleutée sous un bouton noir se voit tout de suite.
  var BRAND = T.couleur;
  var BRAND2 = T.couleur2;
  var OMBRE = T.ombre;

  // Photo de Laura, 128x128, intégrée en base64 : aucune requête réseau,
  // aucun fichier à héberger, identique sur les trois sites.
  var AVATAR =
    'data:image/jpeg;base64,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';


  var SUGGESTIONS = T.suggestions;

  // Relance : si Laura termine sur une question et que la personne ne répond
  // pas, on relance, puis on prend congé. Délais volontairement isolés ici
  // pour être ajustés sans toucher au reste.
  var RELANCE_MS = 60000; // 1 min sans réponse après une question de Laura
  var CONGE_MS = 30000; // puis 30 s plus tard, on prend congé

  // Construit en fin de fichier, une fois bonjourOuBonsoir() défini.
  var WELCOME = '';

  /* ------------------------------------------------------------- session */

  // Au-delà de ce silence, la conversation suivante repart de zéro.
  var EXPIRATION_MS = 30 * 60 * 1000;

  function sid() {
    var k = 'laura_sid';
    var v = sessionStorage.getItem(k);
    if (!v) {
      v = 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(k, v);
    }
    return v;
  }

  /** Efface tout : nouvelle conversation, nouvel identifiant de session. */
  function nouvelleConversation() {
    try {
      sessionStorage.removeItem('laura_hist');
      sessionStorage.removeItem('laura_sid');
      sessionStorage.removeItem('laura_fini');
      sessionStorage.removeItem('laura_vu');
    } catch (e) {}
    return [];
  }

  /**
   * Charge l'historique, sauf si la conversation précédente est terminée
   * (Laura a pris congé) ou trop ancienne. Dans ces deux cas on repart propre :
   * un visiteur qui revient une demi-heure plus tard a une autre question.
   */
  function loadHistory() {
    var fini = sessionStorage.getItem('laura_fini');
    var vu = parseInt(sessionStorage.getItem('laura_vu') || '0', 10);
    if (fini || (vu && Date.now() - vu > EXPIRATION_MS)) return nouvelleConversation();
    try {
      return JSON.parse(sessionStorage.getItem('laura_hist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveHistory(h) {
    try {
      sessionStorage.setItem('laura_hist', JSON.stringify(h.slice(-40)));
      sessionStorage.setItem('laura_vu', String(Date.now()));
    } catch (e) {}
  }

  var history = loadHistory();
  var busy = false;

  /* ----------------------------------------------------------------- CSS */

  var css =
    '.laura-b{position:fixed;right:20px;bottom:20px;width:58px;height:58px;border-radius:50%;' +
    'background:linear-gradient(135deg,' + BRAND + ' 0%,'+BRAND2+' 100%);' +
    'border:0;cursor:pointer;box-shadow:0 8px 28px -6px '+OMBRE+',.5);z-index:2147483000;display:flex;' +
    'align-items:center;justify-content:center;transition:transform .18s}' +
    '.laura-b:hover{transform:scale(1.07);box-shadow:0 12px 34px -6px '+OMBRE+',.58)}' +
    '.laura-b svg{width:26px;height:26px;fill:#fff}' +
    '.laura-b.laura-open svg.laura-i1{display:none}.laura-b .laura-i2{display:none}.laura-b.laura-open .laura-i2{display:block}' +
    // Pastille de disponibilité sur la bulle : verte en permanence, jamais
    // rouge. Laura répond 24h/24, ce n'est pas un badge de notification.
    '.laura-dot{position:absolute;top:-1px;right:-1px;width:14px;height:14px;border-radius:50%;' +
    'background:#22c55e;border:2px solid #fff;animation:lauraPulse 2.2s infinite}' +
    '.laura-w{position:fixed;right:20px;bottom:88px;width:280px;height:415px;background:#fff;border-radius:20px;' +
    'box-shadow:0 24px 64px -12px rgba(15,32,55,.35),0 0 0 1px rgba(15,32,55,.06);' +
    'z-index:2147483000;display:none;flex-direction:column;overflow:hidden;' +
    'font:14px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#1a202c}' +
    '.laura-w.laura-on{display:flex;animation:lauraIn .26s cubic-bezier(.16,1,.3,1)}' +
    '@keyframes lauraIn{from{opacity:0;transform:translateY(14px) scale(.97)}to{opacity:1;transform:none}}' +
    // Dégradé subtil sur l'en-tête plutôt qu'un aplat, et léger relief.
    '.laura-h{background:linear-gradient(135deg,' + BRAND + ' 0%,'+BRAND2+' 100%);color:#fff;' +
    'padding:13px 14px;display:flex;align-items:center;gap:10px;flex:0 0 auto;' +
    'box-shadow:0 1px 0 rgba(255,255,255,.08) inset}' +
    '.laura-av{width:32px;height:32px;border-radius:50%;object-fit:cover;background:#fff;color:' + BRAND + ';' +
    'display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14px;flex:0 0 auto}' +
    '.laura-h b{display:block;font-size:13.5px;font-weight:600;line-height:1.2}' +
    '.laura-h span{font-size:11px;opacity:.82}' +
    // Pastille verte de disponibilité, allumée en permanence.
    '.laura-st{display:flex;align-items:center;gap:5px;opacity:1}' +
    '.laura-live{width:7px;height:7px;border-radius:50%;background:#22c55e;flex:0 0 auto;' +
    'box-shadow:0 0 0 0 rgba(34,197,94,.7);animation:lauraPulse 2.2s infinite}' +
    '@keyframes lauraPulse{0%{box-shadow:0 0 0 0 rgba(34,197,94,.6)}' +
    '70%{box-shadow:0 0 0 6px rgba(34,197,94,0)}100%{box-shadow:0 0 0 0 rgba(34,197,94,0)}}' +
    '.laura-svg{padding:0;overflow:hidden}.laura-svg svg{width:100%;height:100%;display:block}' +
    '.laura-x{margin-left:auto;background:0;border:0;color:#fff;opacity:.8;cursor:pointer;font-size:19px;line-height:1;padding:2px 4px}' +
    '.laura-x:hover{opacity:1}' +
    '.laura-m{flex:1 1 auto;overflow-y:auto;padding:14px 12px;background:linear-gradient(#f7f9fc,#f2f6fb);' +
    'display:flex;flex-direction:column;gap:10px}' +
    '.laura-m::-webkit-scrollbar{width:5px}.laura-m::-webkit-scrollbar-thumb{background:#cbd5e0;border-radius:3px}' +
    '.laura-row{display:flex;gap:6px;align-items:flex-end}' +
    '.laura-row.me{justify-content:flex-end}' +
    '.laura-sm{width:22px;height:22px;border-radius:50%;object-fit:cover;flex:0 0 auto;background:' + BRAND + ';color:#fff;' +
    'display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700}' +
    '.laura-t{max-width:202px;padding:9px 12px;border-radius:16px;white-space:pre-wrap;' +
    'word-wrap:break-word;font-size:13.3px;line-height:1.5}' +
    '.laura-row.bot .laura-t{background:#fff;border:1px solid #e8edf4;border-bottom-left-radius:6px;' +
    'box-shadow:0 1px 2px rgba(15,32,55,.05)}' +
    '.laura-row.me .laura-t{background:linear-gradient(135deg,' + BRAND + ' 0%,'+BRAND2+' 100%);color:#fff;' +
    'border-bottom-right-radius:6px;max-width:212px;box-shadow:0 2px 6px '+OMBRE+',.22)}' +
    '.laura-t a{color:' + BRAND + ';font-weight:600;text-decoration:underline}' +
    '.laura-row.me .laura-t a{color:#fff}' +
    '.laura-t a.laura-pj{display:flex;align-items:center;gap:9px;margin:8px 0;padding:9px 10px;border:1px solid #e3e8ef;' +
    'border-radius:10px;background:#fafbfc;color:#1f2933;font-weight:600;text-decoration:none;white-space:normal;line-height:1.3}' +
    '.laura-t a.laura-pj:hover{border-color:' + BRAND + '}' +
    '.laura-pj-ic{flex:none;font:700 10px/1 system-ui,sans-serif;color:#fff;background:#d93025;border-radius:4px;padding:5px 5px}' +
    '.laura-pj-t{flex:1;font-size:13px}' +
    '.laura-pj-dl{flex:none;color:' + BRAND + ';font-size:15px}' +
    '.laura-s{display:flex;flex-wrap:wrap;gap:5px;padding:0 11px 9px;background:#f7f9fc;flex:0 0 auto}' +
    '.laura-s button{background:#fff;border:1px solid #dde5f0;color:' + BRAND + ';border-radius:16px;' +
    'padding:6px 11px;font-size:11.5px;cursor:pointer;font-family:inherit;line-height:1.3;text-align:left;' +
    'box-shadow:0 1px 2px rgba(15,32,55,.05);transition:all .15s ease}' +
    '.laura-s button:hover{background:' + BRAND + ';border-color:' + BRAND + ';color:#fff;' +
    'transform:translateY(-1px);box-shadow:0 3px 8px '+OMBRE+',.2)}' +
    '.laura-f{border-top:1px solid #e6ebf2;background:#fff;flex:0 0 auto}' +
    '.laura-in{display:flex;align-items:flex-end;gap:6px;padding:8px 9px}' +
    '.laura-in textarea{flex:1;border:1px solid #dde5f0;border-radius:18px;padding:8px 13px;resize:none;' +
    'font:inherit;font-size:13px;max-height:70px;outline:0;font-family:inherit;background:#f7f9fc;' +
    'transition:border-color .15s,background .15s;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}' +
    // Windows dessine une barre de défilement à flèches dès que le texte
    // dépasse une ligne : deux petits chevrons dans un champ arrondi, ça fait
    // amateur. On masque la barre, le champ grandit tout seul jusqu'à 70 px.
    '.laura-in textarea::-webkit-scrollbar{width:0;height:0;display:none}' +
    '.laura-in textarea:focus{border-color:' + BRAND + ';background:#fff;' +
    'box-shadow:0 0 0 3px '+OMBRE+',.08)}' +
    '.laura-send{width:34px;height:34px;border-radius:50%;border:0;cursor:pointer;flex:0 0 auto;' +
    'background:linear-gradient(135deg,' + BRAND + ' 0%,'+BRAND2+' 100%);' +
    'display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px '+OMBRE+',.28);' +
    'transition:transform .15s}' +
    '.laura-send:not(:disabled):hover{transform:scale(1.07)}' +
    '.laura-send:disabled{opacity:.4;cursor:default}' +
    '.laura-send svg{width:15px;height:15px;fill:#fff}' +
    // Attention : pas de déclaration orpheline ici. Un fragment laissé après
    // une règle fait avaler la règle suivante par le parseur CSS, et c'est
    // l'indicateur de frappe qui disparaissait silencieusement.
    '.laura-typ{display:flex;gap:3px;align-items:center;padding:9px 12px;background:#fff;' +
    'border:1px solid #e6ebf2;border-radius:14px;border-bottom-left-radius:5px;width:fit-content;' +
    'box-shadow:0 1px 2px rgba(15,32,55,.05)}' +
    '.laura-typ i{width:5px;height:5px;border-radius:50%;background:#8fa3bd;animation:lauraBl 1.3s infinite}' +
    '.laura-typ i:nth-child(2){animation-delay:.18s}.laura-typ i:nth-child(3){animation-delay:.36s}' +
    // Libellé « Laura écrit » : le client sait qui compose, comme sur les
    // messageries qu'il utilise tous les jours.
    '.laura-typ b{font-size:11px;font-weight:500;color:#8fa3bd;margin-left:5px;white-space:nowrap}' +
    '@keyframes lauraBl{0%,60%,100%{opacity:.3}30%{opacity:1}}' +
    // Note de fin de conversation : discrète, une seule ligne, pas un formulaire.
    '.laura-note{align-self:center;text-align:center;background:#fff;border:1px solid #e8edf4;' +
    'border-radius:14px;padding:10px 12px;box-shadow:0 1px 2px rgba(15,32,55,.05);max-width:236px}' +
    '.laura-note p{margin:0 0 7px;font-size:11.5px;color:#5a6b82;line-height:1.4}' +
    '.laura-note div{display:flex;gap:4px;justify-content:center}' +
    '.laura-note button{width:30px;height:30px;border-radius:50%;border:1px solid #dde5f0;background:#f7f9fc;' +
    'color:' + BRAND + ';font:600 12.5px inherit;cursor:pointer;transition:all .13s}' +
    '.laura-note button:hover{background:' + BRAND + ';border-color:' + BRAND + ';color:#fff;transform:translateY(-1px)}' +
    '.laura-merci{align-self:center;font-size:11.5px;color:#5a6b82}' +
    // Bouton posé sur la page contact du site, pas dans la fenêtre de chat.
    '.laura-cta{display:inline-flex;align-items:center;gap:9px;background:linear-gradient(135deg,' +
    BRAND + ' 0%,'+BRAND2+' 100%);color:#fff;border:0;border-radius:999px;padding:13px 22px;' +
    'font:600 15px/1.2 inherit;cursor:pointer;box-shadow:0 6px 18px -4px '+OMBRE+',.45);' +
    'transition:transform .15s,box-shadow .15s;margin:0 0 22px}' +
    '.laura-cta:hover{transform:translateY(-1px);box-shadow:0 10px 24px -4px '+OMBRE+',.5)}' +
    '.laura-cta img{width:28px;height:28px;border-radius:50%;object-fit:cover}' +
    '.laura-cta i{width:8px;height:8px;border-radius:50%;background:#22c55e;flex:0 0 auto}' +
    '@media(max-width:480px){.laura-w{right:8px;left:8px;width:auto;bottom:78px;height:min(72vh,460px)}' +
    '.laura-t,.laura-row.me .laura-t{max-width:78%}}';

  // data-bulle="off" ne supprime plus la bulle partout : le site a son propre point
  // d'entrée dans l'en-tête sur ordinateur, mais sur mobile cet en-tête est réduit et
  // la bulle reste le moyen le plus direct. Elle y est donc gardée, en plus petit et
  // resserrée dans le coin, pour ne plus recouvrir le bouton de commande du panier.
  if (BULLE_OFF) {
    css +=
      '@media(min-width:750px){.laura-b{display:none}}' +
      '@media(max-width:749px){.laura-b{width:46px;height:46px;right:12px;bottom:12px}' +
      '.laura-b svg{width:21px;height:21px}}';
  }

  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ----------------------------------------------------------------- DOM */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function avatarNode(cls) {
    if (AVATAR) {
      var img = document.createElement('img');
      img.className = cls;
      img.src = AVATAR;
      img.alt = 'Laura';
      return img;
    }
    return el('div', cls, 'R'); // secours si la photo ne charge pas
  }

  var btn = el('button', 'laura-b');
  btn.setAttribute('aria-label', T.ouvrir);
  btn.innerHTML =
    '<svg class="laura-i1" viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/></svg>' +
    '<svg class="laura-i2" viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>' +
    '<span class="laura-dot"></span>';

  var win = el('div', 'laura-w');
  win.setAttribute('role', 'dialog');
  win.setAttribute('aria-label', 'Laura');

  var head = el('div', 'laura-h');
  head.appendChild(avatarNode('laura-av'));
  head.appendChild(
    el(
      'div',
      '',
      '<b>' + T.titre + '</b><span class="laura-st"><i class="laura-live"></i>' + T.statut + '</span>',
    ),
  );
  var close = el('button', 'laura-x', '&times;');
  close.setAttribute('aria-label', T.fermer);
  head.appendChild(close);

  var list = el('div', 'laura-m');
  var sugg = el('div', 'laura-s');

  var foot = el('div', 'laura-f');
  var inputRow = el('div', 'laura-in');
  var ta = document.createElement('textarea');
  ta.rows = 1;
  ta.placeholder = T.saisie;
  ta.setAttribute('aria-label', T.saisie);
  var send = el('button', 'laura-send');
  send.setAttribute('aria-label', T.envoyer);
  send.innerHTML = '<svg viewBox="0 0 24 24"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>';
  inputRow.appendChild(ta);
  inputRow.appendChild(send);
  // Pas de bouton « Parler à un conseiller » : Laura donne d'elle-même le
  // téléphone et l'email quand la question le justifie. Le pied de fenêtre
  // reste une simple zone de saisie.
  foot.appendChild(inputRow);

  win.appendChild(head);
  win.appendChild(list);
  win.appendChild(sugg);
  win.appendChild(foot);
  document.body.appendChild(btn);
  document.body.appendChild(win);

  /* ------------------------------------------------------------- rendu */

  var URL_RE = /(https?:\/\/[^\s<>"')]+)/g;
  var PJ_RE = /\[\[PJ\|([^|\]\n]{1,90})\|(https:\/\/(?:assets\.hncgroupe\.fr|separateur-graisse\.fr)\/[^\]\s"<>]+\.pdf)\]\]/;

  /** Libellé court, pour que le lien se lise dans la phrase. */
  function label(url) {
    if (/\.pdf($|\?)/i.test(url)) return 'la fiche technique';
    if (/calculateur/.test(url)) return 'le calculateur';
    if (/\/products\//.test(url)) return 'la fiche produit';
    if (/\/collections\//.test(url)) return 'la gamme';
    if (/suivi-de-commande/.test(url)) return 'la page de suivi';
    if (/\/pages\/|\/blogs\//.test(url)) return 'cette page';
    return url.replace(/^https?:\/\//, '').slice(0, 40);
  }

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /**
   * Une bulle, comme dans n'importe quel chat. Les URL deviennent de simples
   * liens cliquables dans le texte : pas de carte, pas de bouton, on répond
   * et on laisse la personne réagir.
   */
  function bubble(role, text) {
    var row = el('div', 'laura-row ' + (role === 'user' ? 'me' : 'bot'));
    if (role !== 'user') row.appendChild(avatarNode('laura-sm'));

    // Pièces jointes PDF (fiche technique, notice, catalogue) : le Worker les
    // écrit [[PJ|titre|adresse]] ; on montre une carte à télécharger, jamais
    // l'adresse. Seuls nos propres hébergements passent.
    var morceaux = role === 'user' ? [text.trim()] : text.trim().split(PJ_RE);
    var html = '';
    for (var i = 0; i < morceaux.length; i += 3) {
      // Le lien s'ouvre dans le même onglet : la personne reste dans son
      // parcours, et le widget la suit de page en page (session partagée).
      var bout = morceaux[i];
      if (i + 1 < morceaux.length) bout = bout.replace(/\s+$/, '');
      if (i > 0) bout = bout.replace(/^\s+/, '');
      html += esc(bout).replace(URL_RE, function (u) {
        return '<a href="' + u + '" data-laura-lien="1">' + esc(label(u)) + '</a>';
      });
      if (i + 2 < morceaux.length) {
        html += '<a class="laura-pj" href="' + morceaux[i + 2] + '" target="_blank" rel="noopener">' +
          '<span class="laura-pj-ic">PDF</span><span class="laura-pj-t">' + esc(morceaux[i + 1]) + '</span>' +
          '<span class="laura-pj-dl" aria-hidden="true">&#8595;</span></a>';
      }
    }

    row.appendChild(el('div', 'laura-t', html));
    list.appendChild(row);
    versLeBas();
  }

  /**
   * Le dernier message doit toujours être sous les yeux : à l'ouverture, au
   * changement de page, après une actualisation. Tant que la fenêtre est
   * masquée, la hauteur vaut zéro et le défilement ne prend pas, d'où le
   * second passage différé une fois l'affichage effectif.
   */
  function versLeBas() {
    list.scrollTop = list.scrollHeight;
    setTimeout(function () {
      list.scrollTop = list.scrollHeight;
    }, 60);
  }

  function typing(on) {
    var old = list.querySelector('.laura-tw');
    if (old) old.remove();
    if (!on) return;
    var row = el('div', 'laura-row bot laura-tw');
    row.appendChild(avatarNode('laura-sm'));
    row.appendChild(
      el('div', 'laura-typ', '<i></i><i></i><i></i><b>' + T.ecrit + '</b>'),
    );
    list.appendChild(row);
    versLeBas();
  }

  function renderSuggestions() {
    sugg.innerHTML = '';
    if (history.length) return;
    SUGGESTIONS.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = q;
      b.onclick = function () {
        submit(q);
      };
      sugg.appendChild(b);
    });
  }

  function paint() {
    list.innerHTML = '';
    bubble('assistant', WELCOME);
    history.forEach(function (m) {
      bubble(m.role, m.text);
    });
    renderSuggestions();
    versLeBas();
  }

  /* ---------------------------------------------------------------- envoi */

  function submit(text) {
    text = (text || ta.value).trim();
    if (!text || busy) return;
    ta.value = '';
    ta.style.height = 'auto';
    busy = true;
    send.disabled = true;
    clearRelance(); // la personne a répondu : on annule relance et congé

    // Si Laura avait pris congé, ce message ouvre une nouvelle conversation :
    // on efface le fil précédent pour ne pas mélanger deux sujets.
    if (congePris || sessionStorage.getItem('laura_fini')) {
      history = nouvelleConversation();
      congePris = false;
      paint();
    }

    history.push({ role: 'user', text: text });
    saveHistory(history);
    bubble('user', text);
    renderSuggestions();

    // Une vraie conseillère lit d'abord, puis tape. On reproduit les deux
    // temps : un silence de lecture avant que l'indicateur de frappe
    // apparaisse, puis une durée de frappe proportionnelle à la longueur.
    // Un peu d'aléatoire, parce qu'un délai constant se repère vite.
    var t0 = Date.now();
    var lecture = 800 + Math.round(Math.random() * 700); // 0,8 à 1,5 s de lecture
    setTimeout(function () {
      if (busy) typing(true);
    }, lecture);

    function afficherHumainement(fn, texte) {
      var n = (texte || '').length;
      // Durée totale voulue : 7 s pour une réponse courte, jusqu'à 13 s pour
      // une longue. On raisonne en temps total depuis l'envoi du message,
      // lecture comprise, pour que la personne voie réellement Laura écrire.
      var total = 7000 + Math.min(n * 26, 6000);
      setTimeout(fn, Math.max(0, total - (Date.now() - t0)));
    }

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: text,
        sessionId: sid(),
        page: location.pathname + location.search,
        history: history.slice(-20)
      })
    })
      .then(function (r) {
        return r.json().catch(function () {
          return {};
        });
      })
      .then(function (d) {
        var reply = d.reply || T.panne + EMAIL + (PHONE ? T.panne2 + PHONE + '.' : T.panne2);
        afficherHumainement(function () {
          typing(false);
          history.push({ role: 'assistant', text: reply });
          saveHistory(history);
          bubble('assistant', reply);
          planifierRelance(reply);
          // Laura vient de prendre congé : c'est le moment de la note.
          if (FIN_RE.test(reply)) setTimeout(demanderNote, 1400);
          busy = false;
          send.disabled = false;
          ta.focus();
        }, reply);
      })
      .catch(function () {
        afficherHumainement(function () {
          typing(false);
          bubble('assistant', T.coupure + (PHONE ? PHONE + ' ou à ' + EMAIL : EMAIL) + '.');
          busy = false;
          send.disabled = false;
          ta.focus();
        }, '');
      });
  }

  /* -------------------------------------------- relance et prise de congé */

  var tRelance = null;
  var tConge = null;
  var congePris = false;

  function clearRelance() {
    clearTimeout(tRelance);
    clearTimeout(tConge);
    tRelance = null;
    tConge = null;
  }

  /** Formule de congé du jour ou du soir, dans la langue de la boutique. */
  function salutationHoraire() {
    return T.conge[new Date().getHours() >= 18 ? 1 : 0];
  }

  /** Salutation d'ouverture : jour avant 18h, soir ensuite. */
  function bonjourOuBonsoir() {
    return T.bonjour[new Date().getHours() >= 18 ? 1 : 0];
  }

  function pousserMessage(text) {
    history.push({ role: 'assistant', text: text });
    saveHistory(history);
    bubble('assistant', text);
  }

  /**
   * Planifie la relance après une réponse de Laura.
   * Ne se déclenche que si elle a terminé sur une question.
   */
  function planifierRelance(reply) {
    clearRelance();
    if (congePris) return;
    if (!/\?\s*$/.test(reply.trim())) return;

    tRelance = setTimeout(function () {
      pousserMessage(T.relance);
      tConge = setTimeout(function () {
        congePris = true;
        pousserMessage(salutationHoraire());
        setTimeout(demanderNote, 1400);
        // La conversation est close. Le fil reste affiché tant que la personne
        // regarde, mais au prochain message ou au prochain chargement de page
        // on repart d'une conversation vierge.
        try {
          sessionStorage.setItem('laura_fini', '1');
        } catch (e) {}
      }, CONGE_MS);
    }, RELANCE_MS);
  }

  /* ------------------------------------------------- note de satisfaction */

  /** Envoi discret, sans attendre la réponse : ni note ni signal ne bloquent. */
  function ping(url, data) {
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  var noteDemandee = false;

  /**
   * Une seule demande de note, en fin d'échange, sur une seule ligne.
   * Pas de formulaire, pas de commentaire à rédiger : cinq boutons.
   */
  function demanderNote() {
    if (noteDemandee || sessionStorage.getItem('laura_note')) return;
    var questions = history.filter(function (m) {
      return m.role === 'user';
    }).length;
    if (!questions) return;
    noteDemandee = true;

    var box = el(
      'div',
      'laura-note',
      '<p>' + T.note + '</p>',
    );
    var row = el('div');
    for (var i = 1; i <= 5; i++) {
      (function (n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = n;
        b.setAttribute('aria-label', n + '/5');
        b.onclick = function () {
          envoyerNote(n, box);
        };
        row.appendChild(b);
      })(i);
    }
    box.appendChild(row);
    list.appendChild(box);
    list.scrollTop = list.scrollHeight;
  }

  function envoyerNote(n, box) {
    try {
      sessionStorage.setItem('laura_note', String(n));
    } catch (e) {}
    var merci = el(
      'div',
      'laura-merci',
      n >= 4 ? T.merci_haut : T.merci_bas,
    );
    if (box.parentNode) box.parentNode.replaceChild(merci, box);
    list.scrollTop = list.scrollHeight;
    ping(RATE_URL, { sessionId: sid(), note: n });
  }

  /** Formules de fin employées par Laura : le moment juste pour la note. */
  var FIN_RE = T.fin_re;

  /* ------------------------------------------------------- page « Contact » */

  /**
   * Le widget n'interrompt jamais la navigation.
   *
   * Avant, un clic sur un lien contact ou une adresse mail était intercepté
   * pour ouvrir le chat de force. La personne cherchait une adresse, elle
   * recevait une fenêtre : c'est du démarchage, et ça donne surtout
   * l'impression d'un site qui retient. Les liens fonctionnent maintenant
   * normalement partout, sur les quatre boutiques.
   *
   * Ce qui reste : l'équipe est prévenue quand quelqu'un arrive sur la page
   * contact, parce que c'est le signal d'intention le plus fort du site. Cette
   * alerte est invisible côté visiteur et ne déclenche aucune ouverture.
   */
  var CONTACT_RE = T.contact_re;

  function signalerContact() {
    if (sessionStorage.getItem('laura_contact')) return;
    try {
      sessionStorage.setItem('laura_contact', '1');
    } catch (e) {}
    ping(EVENT_URL, { sessionId: sid(), type: 'contact', page: location.pathname });
  }

  /** Ouverture volontaire : bouton du site ou pastille du widget. */
  function ouvrirChat() {
    toggle(true);
    signalerContact();
  }

  // Seuls les éléments marqués data-laura-chat ouvrent le chat : ils ont été
  // posés exprès pour ça. Aucun autre lien n'est détourné.
  document.addEventListener(
    'click',
    function (e) {
      var n = e.target;
      while (n && n.nodeType !== 1) n = n.parentNode;
      n = n && n.closest ? n.closest('[data-laura-chat]') : null;
      if (!n) return;
      e.preventDefault();
      ouvrirChat();
    },
    true,
  );

  /**
   * Bouton d'ouverture du chat, posé en tête de la page contact du site.
   * C'est le site qui propose un moyen de joindre l'équipe, pas Laura qui
   * s'adresse à quelqu'un : rien ne s'ouvre et aucun message n'est écrit tant
   * que la personne ne clique pas. Elle se présente une fois la fenêtre
   * ouverte, comme à chaque ouverture volontaire.
   *
   * L'équipe est prévenue dès l'arrivée sur la page, que le bouton soit
   * cliqué ou non.
   */
  function poserBoutonContact() {
    if (!CONTACT_RE.test(location.pathname)) return;
    signalerContact();
    if (document.querySelector('.laura-cta')) return;

    // Le formulaire de contact sert d'ancre : le bouton se pose juste avant,
    // là où la personne s'apprête à écrire. Les thèmes Shopify exposent un
    // form[action*="/contact"], le site statique un form#contactForm ; sans
    // formulaire du tout on retombe sur le conteneur principal de la page.
    var form =
      document.querySelector('form[action*="/contact"]') ||
      document.querySelector('#contactForm') ||
      document.querySelector('form[id*="contact" i], form[class*="contact" i]');
    var cible =
      (form && form.parentNode) ||
      document.querySelector('main') ||
      document.querySelector('.contact-grid, .wrap.section, .shop-head');
    if (!cible) return;

    var b = el('button', 'laura-cta');
    b.type = 'button';
    b.innerHTML =
      '<img src="' + AVATAR + '" alt="">' +
      '<span>' + T.cta + '</span><i></i>';
    b.onclick = function () {
      ouvrirChat();
    };
    if (form) cible.insertBefore(b, form);
    else cible.insertBefore(b, cible.firstChild);
  }

  // Ouverture du chat depuis n'importe quel bouton du site.
  window.LauraChat = {
    open: function () {
      toggle(true);
    },
    close: function () {
      toggle(false);
    },
  };

  /* -------------------------------------------------------------- events */

  function toggle(open) {
    var on = open == null ? !win.classList.contains('laura-on') : open;
    win.classList.toggle('laura-on', on);
    btn.classList.toggle('laura-open', on);
    btn.setAttribute('aria-label', on ? T.fermer : T.ouvrir);
    // La fenêtre ouverte suit la personne de page en page : on retient l'état
    // pour la rouvrir au même endroit après un clic ou une actualisation.
    try {
      sessionStorage.setItem('laura_ouvert', on ? '1' : '');
    } catch (e) {}
    // La pastille verte reste en place : elle signale la disponibilité,
    // pas un message non lu. On ne la retire jamais.
    if (on) {
      versLeBas();
      setTimeout(function () {
        versLeBas();
        // preventScroll : sans lui, le navigateur ramène la page sur le champ
        // de saisie au chargement, et la personne perd sa position de lecture.
        try {
          ta.focus({ preventScroll: true });
        } catch (e) {
          ta.focus();
        }
      }, 60);
    }
  }

  btn.onclick = function () { toggle(); };
  close.onclick = function () { toggle(false); };
  send.onclick = function () { submit(); };

  ta.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  });
  ta.addEventListener('input', function () {
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 70) + 'px';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && win.classList.contains('laura-on')) toggle(false);
  });

  // Salutation calculée au chargement : formule du jour ou du soir.
  WELCOME = bonjourOuBonsoir() + T.accueil;

  poserBoutonContact();
  paint();

  // Conversation engagée et fenêtre laissée ouverte : on la rouvre sur la
  // nouvelle page, déjà défilée sur le dernier message. La personne reprend
  // exactement là où elle en était.
  if (history.length && sessionStorage.getItem('laura_ouvert') && !sessionStorage.getItem('laura_fini')) {
    toggle(true);
  }
})();
